import {FC} from 'react'
// Update import path and component name
import {PaymentReports} from '../../modules/reports/PaymentReports' 

interface Props {
  readOnly?: boolean
}

// Rename the page component
const PaymentReportsPage: FC<Props> = ({readOnly = false}) => { 
    return (
        <>
            {/* Use the renamed component */}
            <PaymentReports />
            {/* TODO: Add read-only mode support to PaymentReports component */}
        </>
    )
}

// Update the export
export default PaymentReportsPage
